import React, { PureComponent } from "react";
import { connect } from "react-redux";
import SidebarLink from "./SidebarLink";
import SidebarCategory from "./SidebarCategory";
import {
  changeThemeToDark,
  changeThemeToLight
} from "../../../redux/actions/themeActions";
import { withRouter } from "react-router-dom";
import { signout } from "../../../redux/actions/userActions";
import { setReload } from "../../../redux/actions/apolloActions";
import frameworkMapping from "../../../utils/frameworkMapping";
import moduleMapping from "../../../utils/moduleMapping";
import subModuleMapping from "../../../utils/subModuleMapping";
import generatePDF from '../../../utils/reportGenerator'

class SidebarContent extends PureComponent {
  changeToDark = () => {
    this.props.dispatch(changeThemeToDark());
    this.hideSidebar();
  };

  changeToLight = () => {
    this.props.dispatch(changeThemeToLight());
    this.hideSidebar();
  };

  hideSidebar = () => {
    this.props.onClick();
  };

  signoutUser() {
    this.props.signout();
    this.props.history.push("/");
  }

  updateFromGettingStartd(){
    localStorage.setItem('fromGettingStarted', false)
  }

  render() {
    return this.props.user && this.props.settings ? (
      <div className="sidebar__content">
        <SidebarLink
          title="Getting Started"
          id="get-started"
          icon="question-circle "
          route="/app/getting-started"
        /><hr />
        <SidebarLink
          title="Dashboard"
          id="dashboard-nav"
          icon="home"
          route="/app/dashboard"
        /> 
        {this.props.user &&
        this.props.user["cognito:groups"] &&
        this.props.user["cognito:groups"].find(e => {
          return e.includes("Admin") || e.includes("Manager");
        }) &&
        this.props.settings &&
        this.props.settings.modules &&
        this.props.settings.modules.includes(moduleMapping.ASSESSMENT) ? (
          <SidebarLink
            id="assessment-dropdown"
            title="Assessment"
            icon="pencil"
            route="/app/assessment"
            onClick={() => {
              this.updateFromGettingStartd();
            }}
          />
        ) : null }
        {["null"].includes(process.env.REACT_APP_ENV) && (
          <SidebarLink
            id="recommendations-nav"
            title="Recommendations"
            icon="rocket"
            route="/app/recommendations"
          />
        )}
        {this.props.settings &&
        this.props.settings.modules &&
        this.props.settings.modules.includes(moduleMapping.PLAYBOOK) ? (
          <SidebarLink
            id="playbook-dropdown"
            title="Compliance Playbook"
            icon="book"
            route="/app/playbook/hipaa"
          />
        ) : null}
        {this.props.settings &&
        this.props.settings.modules &&
        this.props.settings.modules.includes(moduleMapping.COMPLIANCE) ? (
          <SidebarCategory
            id="compliance-dropdown"
            title="Compliance"
            icon="layers"
          >
            {this.props.enabledFrameworks &&
            this.props.enabledFrameworks.length > 0
              ? this.props.enabledFrameworks.map(f => {
                  return f.id ? (
                    <li
                      id={`${frameworkMapping[f.id].name}-compliance-nav`}
                      key={f.id}
                      className="sidebar__link"
                      onClick={() => {
                        this.props.history.push(
                          `/app/compliance/${frameworkMapping[f.id].path}`
                        )
                        localStorage.setItem('path', frameworkMapping[f.id].path)
                        localStorage.setItem('status', frameworkMapping[f.id].flat)
                      }  
                      }
                    >
                      <p className="sidebar__link-title">
                        {frameworkMapping[f.id].humanName}
                      </p>
                    </li>
                  ) : null;
                })
              : null}
          </SidebarCategory>
        ) : null}
        {this.props.user &&
        this.props.user["cognito:groups"] &&
        this.props.user["cognito:groups"].find(e => {
          return e.includes("Admin") || e.includes("Manager");
        }) &&
        this.props.settings &&
        this.props.settings.modules &&
        this.props.settings.modules.includes(moduleMapping.ASSESSMENT) ? (
          <SidebarLink
            title="Policy Generator"
            id="policy-generator"
            icon="book"
            route="/app/policy-generator"
          />
        ) : null}
        {["null"].includes(process.env.REACT_APP_ENV) && (
          <SidebarCategory
            id="security-awareness-dropdown"
            title="Security Awareness"
            icon="warning"
          >
            <li
              id="policies-nav"
              className="sidebar__link"
              onClick={() => this.props.history.push("/app/policies")}
            >
              <p className="sidebar__link-title"> Policies </p>
            </li>
            <li
              id="training-nav"
              className="sidebar__link"
              onClick={() => this.props.history.push("/app/training")}
            >
              <p className="sidebar__link-title"> Training </p>
            </li>
          </SidebarCategory>
        )}

        {this.props.settings &&
        this.props.settings.modules &&
        this.props.settings.modules.includes(moduleMapping.EVIDENCE_LOCKER) ? (
          <SidebarLink
            id="evidence-locker"
            title="Evidence Locker"
            icon="lock"
            route="/app/<tbd>"
          />
        ) : null}
        {["null"].includes(process.env.REACT_APP_ENV) && (
          <SidebarLink
            title="Posture Report"
            id="posture-report-nav"
            icon="file-empty"
            route="/app/posture-report"
          />
        )}
        {["demo"].includes(process.env.REACT_APP_ENV) && (
          <SidebarLink
            title="Vendor Assessments"
            id="vendor-assessments"
            icon="list"
            route="/app/vendor-assessments"
          />
        )}
        {this.props.settings.modules.includes(moduleMapping.TRAINING)?
          (<SidebarCategory
            id="training-nav"
            title="Training"
            icon="bullhorn"
          >
              {this.props.settings.sub_modules.map((subModule)=>{
                if(subModule.sub_module_name == 'training'){return subModule.categories}})[0].includes(subModuleMapping.HIPAA_TRAINING)?
              (
                <li
                  id="hippa-playbook-nav"
                  className="sidebar__link"
                  onClick={() => this.props.history.push("/app/training/hipaa")}
                >
                  <p className="sidebar__link-title">HIPAA</p>
                </li>
              )
              :null}
              {this.props.settings.sub_modules.map((subModule)=>{
                if(subModule.sub_module_name == 'training'){return subModule.categories}})[0].includes(subModuleMapping.SECURITY_TRAINING)?
              (
                <li
                  id="hippa-playbook-nav"
                  className="sidebar__link"
                  onClick={() => this.props.history.push("/app/training/security")}
                >
                  <p className="sidebar__link-title">Security</p>
                </li>
              )
              :null}
              {this.props.settings.sub_modules.map((subModule)=>{
                if(subModule.sub_module_name == 'training'){return subModule.categories}})[0].includes(subModuleMapping.PCI_TRAINING)?
              (
                <li
                  id="hippa-playbook-nav"
                  className="sidebar__link"
                  onClick={() => this.props.history.push("/app/training/pci")}
                >
                  <p className="sidebar__link-title">PCI</p>
                </li>
              )
              :null}
              {/* <li
                id="hippa-playbook-nav"
                className="sidebar__link"
                onClick={() => this.props.history.push("/app/training/hipaaawarenessquiz")}
              >
                <p className="sidebar__link-title">HIPAA Quiz</p>
              </li>
              <li
                id="hippa-playbook-nav"
                className="sidebar__link"
                onClick={() => this.props.history.push("/app/training/securityawareness")}
              >
                <p className="sidebar__link-title">Security Quiz</p>
              </li> */}
            </SidebarCategory>):null
        }
        {this.props.settings &&
        this.props.settings.modules &&
        this.props.settings.modules.includes(moduleMapping.MARKETPLACE) ? (
          <SidebarLink
            title="Marketplace"
            id="marketplace-nav"
            icon="store"
            route="/app/marketplace"
          />
        ) : null}
        <hr />
        

         {/*this.props.settings &&
        this.props.settings.modules &&
        this.props.settings.modules.includes(moduleMapping.MARKETPLACE) ? (
          <SidebarLink
            title="Risk Management"
            id="risk-mgmt-nav"
            icon="rocket"
            route="/app/posture-report"
          />
        ) : null*/}
        {this.props.user &&
        this.props.user["cognito:groups"] &&
        this.props.user["cognito:groups"].find(e => {
          return e === "ContentEditor";
        }) ? (
          <SidebarCategory
            id="content-management-dropdown"
            title="Content Management"
            icon="cog"
          >
            <li
              id="content-management"
              className="sidebar__link"
              onClick={() => this.props.history.push("/app/content")}
            >
              <p className="sidebar__link-title">Frameworks</p>
            </li>
            <li
              id="edit-hippa-playbook"
              className="sidebar__link"
              onClick={() =>
                this.props.history.push("/app/content/hipaa-playbook")
              }
            >
              <p className="sidebar__link-title">HIPAA Playbook</p>
            </li>
            {/*<li
              id="company-profile-report"
              className="sidebar__link"
              onClick={() =>
                generatePDF(localStorage.getItem('assessment'), JSON.stringify(localStorage.getItem('hipaa')))
                //this.props.history.push("/app/content/hipaa-playbook")
              }
            >
              <p className="sidebar__link-title">Company Profile Report</p>
            </li>*/}
            {/*<li
              id="company-profile-report"
              className="sidebar__link"
              onClick={() =>
                getAllActive()
                //this.props.history.push("/app/content/hipaa-playbook")
              }
            >
              <p className="sidebar__link-title">Export All Active</p>
            </li>
            <li
              id="company-profile-report"
              className="sidebar__link"
              onClick={() =>
                getDelinquentMonthly()
                //this.props.history.push("/app/content/hipaa-playbook")
              }
            >
              <p className="sidebar__link-title">Export Undone Monthly</p>
            </li>*/}
            </SidebarCategory>
          
        ) : null}
        {/* { this.props.tenant && this.props.tenant.logo !== null ? 

          <div className="sidebar__link-powered-by-posture justify-content-bottom" 
          style={{
            position: 'absolute',
            bottom: '0'}}>
          <p style={{
            marginTop: '-30px',
            color: 'white',
            fontWeight: '600'}} 
            >Powered by Posture</p>
          </div>
          : null} */}
        
      </div>
    ) : null;
  }
}

function mapStateToProps(state) {
  return {
    user: state.auth.user,
    settings: state.auth.settings,
    refetchQuery: state.apollo.refetch,
    enabledFrameworks: state.controlsData.enabledFrameworks,
    tenant: state.auth.tenant
  };
}

export default withRouter(
  connect(mapStateToProps, { signout, setReload })(SidebarContent)
);



// WEBPACK FOOTER //
// ./src/pages/_layout/sidebar/SidebarContent.js